import { render, staticRenderFns } from "./AddExperienceButton.vue?vue&type=template&id=b4624fae&scoped=true&"
import script from "./AddExperienceButton.vue?vue&type=script&lang=js&"
export * from "./AddExperienceButton.vue?vue&type=script&lang=js&"
import style0 from "./AddExperienceButton.vue?vue&type=style&index=0&id=b4624fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4624fae",
  null
  
)

export default component.exports